<div class="settings-menu">
    <em [class]="containWithinAspectRatio ? 'fa fa-arrows-alt' : 'fa fa-expand'"
        (click)="toggleContainWithinAspectRatio()"></em>
    <em class="fa fa-undo" (click)="rotateLeft()"></em>
    <em class="fa fa-undo voltear" (click)="rotateRight()"></em>
    <em class="fa fa-sort horizontal" (click)="flipHorizontal()"></em>
    <em class="fa fa-sort" (click)="flipVertical()"></em>
    <em class="fa fa-search-minus" (click)="zoomOut()"></em>
    <em class="fa fa-search-plus" (click)="zoomIn()"></em>
</div>

<image-cropper style="width: 100%; height: 600px" class="d-flex align-items-center justify-content-center"
    [imageURL]="imageURL" [maintainAspectRatio]="true" [canvasRotation]="canvasRotation" [transform]="transform"
    [containWithinAspectRatio]="containWithinAspectRatio" [disabled]="true" [aspectRatio]="1 / 1" [alignImage]="'left'"
    [roundCropper]="false">
</image-cropper>